import { render, staticRenderFns, recyclableRender, components } from "./count.vue?vue&type=template&id=24f0a8f7&scoped=true&"
var renderjs
import script from "./count.vue?vue&type=script&lang=js&"
export * from "./count.vue?vue&type=script&lang=js&"
import style0 from "./count.vue?vue&type=style&index=0&id=24f0a8f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0a8f7",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/count/count.vue"
export default component.exports